<template>
  <div class="wh100">
    <OperationMaintenanceRecord
      ref="OperationMaintenanceRecord"
      workOrderType="2"
    ></OperationMaintenanceRecord>
  </div>
</template>
<script>
import OperationMaintenanceRecord from '@/views/Operation/OperationMaintenanceRecord/OperationMaintenanceRecord.vue'
export default {
  data() {
    return {}
  },
  props: {},
  components: { OperationMaintenanceRecord },
  methods: {},
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped></style>
